import { GradientCard } from "@/containers/GradientCard";
import { BREAKPOINTS } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";
import { useNavigate } from "react-router";
import { useMediaQuery } from "usehooks-ts";

import { BaseModalV2 } from "../BaseModalV2";

const PREMIUM_FEATURES = [
  "chains",
  "squadBuilder",
  "sbcSolver",
  "myClub",
  "noAds",
] as const;

interface PremiumSubscriptionModalProps {
  data?: unknown;
  onClose: () => void;
}

export const PremiumSubscriptionModal = ({
  onClose,
}: PremiumSubscriptionModalProps) => {
  const { t } = useTranslation("subscription");
  const navigate = useNavigate();
  const isSmallDesktop = useMediaQuery(BREAKPOINTS.SMALL_DESKTOP.query);

  const handleSubscribe = () => {
    navigate("/subscription");
    onClose();
  };

  const Content = () => (
    <div className="flex flex-col gap-2 large-desktop:gap-4">
      {PREMIUM_FEATURES.map((feature) => (
        <div key={feature} className="flex items-center gap-3">
          <div className="w-2 h-2 rounded-[1px] bg-evolution-secondary shadow-sm shrink-0" />
          <span className="font-oswald touch-device:text-lg text-dark-primary leading-tight">
            {t(`premiumModal.features.${feature}` as const)}
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <BaseModalV2
      title={t("premiumModal.title")}
      primaryAction={{
        label: t("premiumModal.subscribe"),
        onClick: handleSubscribe,
      }}
      secondaryAction={{
        label: t("premiumModal.continueWithout"),
        onClick: onClose,
      }}
      onClose={onClose}
      imageUrl={
        import.meta.env.VITE_APP_ASSETS_BASE_URL +
        "/evolution-builder/unlock-chains-right-side.png"
      }
      imageAlt="premium-feature"
    >
      <p className="text-sm touch-device:text-base text-dark-tertiary mb-4 large-desktop:mb-6">
        {t("premiumModal.body")}
      </p>

      {isSmallDesktop ? (
        <Content />
      ) : (
        <GradientCard>
          <Content />
        </GradientCard>
      )}
    </BaseModalV2>
  );
};
